import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import style from "./index.module.scss";
import classNames from 'classnames';
import payImg from "./images/pay.svg";
import arrowImg from "./images/arrow.svg";
/**
 * 升级提示条组件
 * @param props UpdateAlertProps
 */
const UpdateAlert = props => {
  const {
    className,
    button = '立即升级',
    botton,
    onBtnClick,
    content = '',
    size = 'm',
    hasImg = true,
    type = 'default'
  } = props;
  const [bgSize, setBgSize] = useState(2);
  const alertRef = useRef(null);

  // 点击立即升级
  const handleUpdate = useCallback(() => {
    if (onBtnClick) {
      onBtnClick();
      return;
    }
  }, []);

  // 如果宽度小于300，用小图背景
  useEffect(() => {
    const alertWidth = alertRef.current?.clientWidth || 0;
    if (alertWidth < 300) {
      setBgSize(1);
    }
  }, []);
  const defaultCom = /*#__PURE__*/React.createElement("div", {
    style: props.style,
    ref: alertRef,
    className: classNames(className, style['update-alert-main'], style[`alert-main-${size}`], style[`alert-main-bg-${bgSize}`])
  }, /*#__PURE__*/React.createElement("div", {
    className: style['alert-left']
  }, hasImg && /*#__PURE__*/React.createElement("img", {
    className: style['pay-img'],
    src: payImg
  }), /*#__PURE__*/React.createElement("div", null, content)), /*#__PURE__*/React.createElement("div", {
    className: style['alert-right']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['alert-btn'],
    onClick: handleUpdate
  }, botton ? botton : button)));

  // 按钮单独写一个样式和功能
  const buttonCom = /*#__PURE__*/React.createElement("div", {
    style: props.style,
    ref: alertRef,
    onClick: handleUpdate,
    className: classNames(className, style['update-alert-main'], style['update-btn-main'], style[`alert-main-bg-${bgSize}`])
  }, /*#__PURE__*/React.createElement("div", {
    className: style['alert-left']
  }, hasImg && /*#__PURE__*/React.createElement("img", {
    className: style['pay-img'],
    src: payImg
  }), /*#__PURE__*/React.createElement("div", null, content), /*#__PURE__*/React.createElement("img", {
    className: style['arrow-img'],
    src: arrowImg
  })));
  return type === 'default' ? defaultCom : buttonCom;
};
UpdateAlert.displayName = 'cc-update-alert';
export default /*#__PURE__*/memo(UpdateAlert);